<template>
  <div class="bg">
    <el-container>
      <el-header height="105px" style="position: fixed; background-color: #334970ee;padding: 0; z-index: 999;height: 100px;">
        <home-head @click-page="setCurrentPage"></home-head>
      </el-header>
      <el-main style="padding-top: 100px;overflow: auto">
        <home-body :currentPage="currentPage" @click-page="setCurrentPage"></home-body>
      </el-main>
    </el-container>
    
  </div>
</template>

<script>
import HomeHead from "./components/home-head";
import HomeBody from "./components/home-body";

export default {
  components: {
    'home-head': HomeHead,
    'home-body': HomeBody
  },
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {
    setCurrentPage(i) {
      this.currentPage = i
    }
  }
}
</script>
<style scoped>
.bg{
  background: #e7eef8;
  background-size: 130% 175%;
  overflow-y: auto;
  height: 100%;
}
</style>
